import { Device } from 'clipsal-cortex-types/src/api/api-site';
import { SCHNEIDER_ELECTRIC_MANUFACTURER_ID } from 'clipsal-cortex-utils/src/constants/common-constants';

import { SCHNEIDER_CHARGE_PATH } from './constants';

export const getConfigurableDeviceRoute = (siteDevice: Device, backURL?: string): string | null => {
  if (siteDevice.manufacturer_id === SCHNEIDER_ELECTRIC_MANUFACTURER_ID && siteDevice.device_type === 'EV_CHARGER') {
    const isPreviouslyConnectedEVCharger = siteDevice.operating_state && siteDevice.operating_state !== 'NOT_CONNECTED';
    // For old Schneider EV Chargers,take user directly to power cycle instructions
    const subPath = isPreviouslyConnectedEVCharger ? 'power_cycle_instructions' : 'start';
    return `${SCHNEIDER_CHARGE_PATH}/${siteDevice.id}/${subPath}${
      backURL ? `?backURL=${encodeURIComponent(backURL)}` : ''
    }`;
  }
  return null;
};
